/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import Flickity from 'flickity';
import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

import getCurrentMediaQuery from '../helpers/_getCurrentMediaQuery';

/* ====================================================================
   BEHAVIOURS —> FLICKITY SLIDER
   ==================================================================== */

const flickitySlider = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'flickitySlider',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    settings() {
      /* Set all flickity properties. Full API can be found here:
       * https://flickity.metafizzy.co/options.html
       */
      const properties = {
        wrapAround: false,
        initialIndex: 0,
        selectedAttraction: 0.01,
        friction: 0.15,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        cellAlign: 'left',
        lazyLoad: 2,
      };
      return properties;
    },
    bindEvents() {
      const indicator = document.querySelector('[data-js=flickityIndicator]');

      const noOfCells = this.slider.cells.length;

      let i;

      if (indicator) {
        for (i = 0; i < noOfCells; i++) {
          if (i == 0) {
            indicator.innerHTML += '<div class="pagination__bar pagination__bar--active"></div>';
          } else {
            indicator.innerHTML += '<div class="pagination__bar"></div>';
          }
        }
      }

      this.slider.on('change', function (cellIndex) {
        // When I cick a carousel slide
        // Check if it's before or after this

        const indicator = document.querySelectorAll('.pagination__bar');

        if (indicator) {
          // indicator[cellIndex].classList.add('pagination__bar--active');
          // indicator.forEach(function(el, index, obj) {
          //   if (!index == cellIndex) {
          //     el.classList.remove('pagination__bar--active');
          //   }
          // });
        }

        const totalCells = noOfCells - 1;
      });

      this.slider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
        // console.log(event);
        if (event.target.classList.contains('featured-content--video')) {
          // console.log('found it');
          const videoThumb = event.target;
          const playBtn = videoThumb.querySelector('[data-videothumb-play]');
          const embed = videoThumb.querySelector('[data-videothumb-embed]');
          const thumb = document.querySelector('[data-videothumb-thumb]');

          fade({
            el: thumb,
            type: 'out',
            duration: 200,
            display: 'block',
          });
        } else {
          // console.log('not found');
        }
      });
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      // console.log(this.name + ':', this);

      this.slider = new Flickity(this.node, this.settings());

      HSC.slider = this.slider;

      this.bindEvents();

      // this.bindEvents();
    },
  },
);

export default flickitySlider;
